import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Document, ProjectProfile } from '@ceres/domain';

@Injectable({
    providedIn: 'root'
})
export class ProjectDataService {
    projectData: ProjectProfile;
    private isValid: boolean;
    private hasChanges: boolean;
    private pendingProjectPatch: Partial<ProjectProfile> = {};
    private pendingProjectId?: number;
    public projectSource$$ = new BehaviorSubject<ProjectProfile>(null);
    currentProject$ = this.projectSource$$.asObservable();
    private documentsSource = new BehaviorSubject([]);
    documents = this.documentsSource.asObservable();
    // public documentsToUpload = false;

    storeProject(project: ProjectProfile) {
        this.projectSource$$.next(project);
        this.hasChanges = true;
    }

    setProjectData(data: ProjectProfile) {
        this.projectSource$$.next(data);
    }

    stageProjectPatch(patch: Partial<ProjectProfile>): void {
        const project = this.projectSource$$.value;
        const updatesDiscount =
            Object.prototype.hasOwnProperty.call(patch, 'discountValue') ||
            Object.prototype.hasOwnProperty.call(patch, 'discountApplicable');
        if (updatesDiscount && project?.projectValueManuallyEdited === true) {
            project.projectValueManuallyEdited = false;
        }
        this.pendingProjectId = this.projectSource$$.value?.id;
        this.pendingProjectPatch = { ...this.pendingProjectPatch, ...patch };
        this.hasChanges = true;
    }

    getPendingProjectValue<K extends keyof ProjectProfile>(key: K): ProjectProfile[K] | undefined {
        if (this.pendingProjectId !== this.projectSource$$.value?.id) return undefined;
        return this.pendingProjectPatch[key] as ProjectProfile[K] | undefined;
    }

    applyPendingProjectPatch(project: ProjectProfile): void {
        if (this.pendingProjectId !== project.id) return;
        Object.assign(project, this.pendingProjectPatch);
    }

    clearPendingProjectPatch(): void {
        this.pendingProjectPatch = {};
        this.pendingProjectId = undefined;
    }

    changeValidity(state: boolean) {
        this.isValid = state;
    }

    getValidity(): boolean {
        return this.isValid;
    }

    // not used
    /* storeDocuments(documents: Document[]) {
    this.documentsSource.next(documents);
  }*/

    setDocuments(documents: Document[]) {
        this.documentsSource.next(documents);
    }

    setChanges(changed: boolean): void {
        this.hasChanges = changed;
    }

    getChanges(): boolean {
        return this.hasChanges;
    }
}
